import { sgBaseUrl } from '@fs/zion-config'
import { getSessionId } from '@fs/zion-session'
import axios from '@fs/zion-axios'

const baseUrl = sgBaseUrl || 'https://sg31b0.familysearch.org'
const artifactStoreUrl = `${baseUrl}/service/msg-artifact/user-portrait`

const editPortrait = (payload, artifactId) => {
  return axios.put(`${artifactStoreUrl}/${artifactId}`, payload)
}
const formatPortraitPayload = (cropArea, file) => {
  const { x, y, w: width, h: height, rotation = 0 } = cropArea
  const payload = new FormData()
  payload.append('x', x)
  payload.append('y', y)
  payload.append('width', width)
  payload.append('height', height)
  payload.append('rotation', rotation % 360)
  payload.append('mediaType', file.type)
  payload.append('file', file)

  return payload
}
export const setProfilePortrait = async (file, cropArea, artifactId) => {
  const { x, y, w: width, h: height, rotation = 0 } = cropArea
  if (artifactId) return editPortrait({ x, y, width, height, rotation }, artifactId)
  const payload = formatPortraitPayload(cropArea, file)

  return axios.post(artifactStoreUrl, payload)
}

const addQueryParam = (href, { key, value }) => {
  if (!href) return ''

  const url = new URL(href, window.location.origin)
  url.searchParams.set(key, value)
  return url.href
}
export const formatAuthorizedImageUrl = (href) => {
  if (href?.indexOf('familysearch') === -1) return href
  const sessionId = getSessionId()
  const paramName = 'sessionId'
  return addQueryParam(href, { key: paramName, value: sessionId })
}
export const getProfilePortrait = async (cisId) => {
  const url = new URL(artifactStoreUrl, window.location.origin)
  url.searchParams.set('cisId', cisId)
  const portraitData = await axios.get(url.href)
  return {
    ...portraitData.data,
    filename: portraitData.data.filename,
    url: portraitData.data.originalUri,
    // The backend has added an s, and this change is in Beta. The one without a 's' can be deleted once this goes to prod.
    avatarUrl: formatAuthorizedImageUrl(portraitData.data.thumb200Uri || portraitData.data.thumb200sUri),
  }
}

export const deleteProfilePortrait = async (filename) => {
  return axios.delete(`${artifactStoreUrl}/${filename}`)
}
